import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * In-page anchor navigation matching the static prototype (#services, #contact, etc.)
 */
const HashLink = ({ to, children, className = '', onClick, ...rest }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hash = to.startsWith('#') ? to : `#${to}`;

  const handleClick = (e) => {
    e.preventDefault();
    onClick?.(e);

    const scrollToHash = () => {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    if (location.pathname !== '/') {
      navigate({ pathname: '/', hash });
      setTimeout(scrollToHash, 150);
    } else {
      window.history.pushState(null, '', hash);
      scrollToHash();
    }
  };

  return (
    <a href={hash} className={className} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};

export default HashLink;
